import * as React from "react";
import { styled } from "utils/stitches.config";
import { Box, Portal } from "../../atoms";
import { Burger, BurgerProps } from "./burger";

type Props = BurgerProps;

const NavigationBurger: React.FC<Props> = ({ ...props }) => {
  return (
    <Box>
      <Portal>
        <StyledBurger {...props} />
      </Portal>
    </Box>
  );
};

const StyledBurger = styled(Burger, {
  position: "fixed",
  top: "$3",
  right: "$3",
  zIndex: 10,
  backgroundColor: "$white",
  borderRadius: "50%",
  transition: "transform 350ms",
});

export { NavigationBurger };
